import React from 'react';
import PropTypes from 'prop-types';

const Flash = ({ fill = '#F2B81A' }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.856 7.83008H10.249L14.226 0.832787C14.3244 0.660431 14.3238 0.448936 14.2244 0.277161C14.1244 0.10553 13.9411 0 13.7427 0H7.063C6.82338 0 6.61073 0.153366 6.5352 0.380516L3.19536 10.4372C3.13825 10.6068 3.16709 10.7938 3.27146 10.9389C3.37641 11.0841 3.54442 11.1699 3.72315 11.1699H8.44547L5.4383 18.2243C5.3306 18.475 5.42091 18.7669 5.65139 18.913C5.87811 19.058 6.18266 19.0199 6.3656 18.8131L15.2718 8.75651C15.4175 8.59285 15.4535 8.35845 15.3638 8.15899C15.274 7.95895 15.0751 7.83008 14.856 7.83008Z"
      fill={fill}
    />
  </svg>
);

Flash.propTypes = {
  fill: PropTypes.string,
};

export default Flash;
